import { render, staticRenderFns } from "./CurrentStock.vue?vue&type=template&id=cbb75f00&scoped=true&"
import script from "./CurrentStock.vue?vue&type=script&lang=js&"
export * from "./CurrentStock.vue?vue&type=script&lang=js&"
import style0 from "./CurrentStock.vue?vue&type=style&index=0&id=cbb75f00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb75f00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDataTable,VIcon,VRow})
